<div *ngIf="type == 'vendor' || type == 'professional'; else back">
    <app-vendor-order-details *ngIf="type == 'vendor'" [order]="order"></app-vendor-order-details>
    <app-professional-order-details *ngIf="type == 'professional'" [order]="order"></app-professional-order-details>
</div>

<ng-template #back >
    <div *ngIf="!loading && !order" class="mx-auto text-center mt-40">Error Loading Order</div>
    <a routerLink="/account/orders" class="btn btn-xs btn-secondary mx-auto ">{{"back_to_list"|translate}}</a>
</ng-template>
